import React, { useEffect, useState } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import "./historic.css";
import { useForm, Controller } from "react-hook-form";
import CustomDOBPicker from "../../components/CustomDOBPicker";
import axios from "axios";
import base_url from "../../api/bootapi";
import AsyncSelect from "react-select/async";
import CustomButton from "../../components/CustomButton";
import moment from "moment";
import FlightCard from "./FlightCard";
import { Loader, Radio } from "@mantine/core";
import { Link } from "react-router-dom";
import {
  IconChartBar,
  IconLiveView,
  IconTemperatureSun,
} from "@tabler/icons-react";

const FlightTracking = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      airline: "",
      flightNumber: "",
      departureDate: null,
    },
  });

  const [defaultAirlineOptions, setDefaultAirlineOptions] = useState([]);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [flightData, setFlightData] = useState([]);
   const [searchBy,setSearchBy]=useState('airline_name')

  const [loading, setLoading] = useState(false);

  // const onSubmit = async (data) => {
  //   setLoading(true);

  //   const requestData = {
  //     airline_code: data.airline.hub_code,
  //     flight_number: data.flightNumber,
  //     flight_date: moment(data.departureDate, "MM-DD-YYYY").format(
  //       "YYYY/MM/DD"
  //     ),
  //   };

  //   try {
  //     const response = await axios.post(
  //       `${base_url.api1}/tourapp/flight_states`,
  //       requestData
  //     );

  //     const flightData = response.data?.schedule;
  //     console.log(flightData);

  //     const airports = flightData.appendix?.airports ?? [];
  //     console.log(flightData.appendix);
  //     console.log(flightData.appendix?.airports);

  //     let flightOptionsData = null;

  //     if (flightData?.flightStatuses?.length > 0) {
  //       console.log("Calling");
  //       const departureFsCode =
  //         flightData?.flightStatuses[0]?.departureAirportFsCode;
  //       const arrivalFsCode =
  //         flightData?.flightStatuses[0]?.arrivalAirportFsCode;

  //       const departureAirport = airports.find(
  //         (a) => a.fs === departureFsCode
  //       )?.name;
  //       const arrivalAirport = airports.find(
  //         (a) => a.fs === arrivalFsCode
  //       )?.name;

  //       const departureScheduled =
  //         flightData?.flightStatuses[0]?.operationalTimes
  //           ?.scheduledGateDeparture?.dateLocal;
  //       const departureEstimated =
  //         flightData?.flightStatuses[0]?.operationalTimes
  //           ?.estimatedGateDeparture?.dateLocal;
  //       const departureActual =
  //         flightData?.flightStatuses[0]?.operationalTimes?.actualGateDeparture
  //           ?.dateLocal;

  //       const departureActualRunway =
  //         flightData?.flightStatuses[0]?.operationalTimes?.actualRunwayDeparture
  //           ?.dateLocal;
  //       const arrivalScheduled =
  //         flightData?.flightStatuses[0]?.operationalTimes?.scheduledGateArrival
  //           ?.dateLocal;
  //       const arrivalEstimated =
  //         flightData?.flightStatuses[0]?.operationalTimes?.estimatedGateArrival
  //           ?.dateLocal;
  //       const arrivalActual =
  //         flightData?.flightStatuses[0]?.operationalTimes?.actualGateArrival
  //           ?.dateLocal;
  //       const arrivalActualRunway =
  //         flightData?.flightStatuses[0]?.operationalTimes?.actualRunwayArrival
  //           ?.dateLocal;
  //       const status = flightData?.flightStatuses[0]?.status;
  //       const flightDate =
  //         flightData?.flightStatuses[0]?.departureDate?.dateLocal;
  //       const flightNumber =
  //         flightData?.flightStatuses[0]?.primaryCarrierFsCode +
  //         " " +
  //         flightData?.flightStatuses[0]?.flightNumber;
  //       const departureTerminal =
  //         flightData?.flightStatuses[0]?.airportResources?.departureTerminal;
  //       const arrivalTerminal =
  //         flightData?.flightStatuses[0]?.airportResources?.arrivalTerminal;

  //       const departureTimezone = airports.find(
  //         (a) => a.fs === departureFsCode
  //       )?.timeZoneRegionName;
  //       const arrivalTimezone = airports.find(
  //         (a) => a.fs === arrivalFsCode
  //       )?.timeZoneRegionName;
  //       console.log(
  //         departureFsCode,
  //         arrivalFsCode,
  //         departureAirport,
  //         arrivalAirport
  //       );

  //       flightOptionsData = [
  //         {
  //           flight_status: status,
  //           flight_date: flightDate,
  //           flight_number: flightNumber,
  //           departure: {
  //             airport: departureAirport,
  //             iata: departureFsCode,
  //             scheduled: departureScheduled,
  //             estimated: departureEstimated,
  //             actual: departureActual,
  //             actual_runway: departureActualRunway,

  //             terminal: departureTerminal,
  //             timezone: departureTimezone,
  //           },
  //           arrival: {
  //             airport: arrivalAirport,
  //             iata: arrivalFsCode,
  //             scheduled: arrivalScheduled,
  //             estimated: arrivalEstimated,
  //             actual: arrivalActual,
  //             actual_runway: arrivalActualRunway,
  //             terminal: arrivalTerminal,
  //             timezone: arrivalTimezone,
  //           },
  //         },
  //       ];
  //     }
  //     setFlightData(flightOptionsData);
  //     setLoading(false);
  //   } catch (error) {
  //     setFlightData(null);
  //     setLoading(false);
  //     console.error("Error fetching flight options:", error);
  //   }
  // };


    const onSubmit = async (data) => {
    setLoading(true);

    const requestData = {
      airline_code: data.airline.hub_code,
      flight_number: data.flightNumber,
      flight_date: moment(data.departureDate, "MM-DD-YYYY").format(
        "YYYY-MM-DD"
      ),
    };

    try {
      const response = await axios.post(
        `${base_url.api1}/tourapp/flightaware_details`,
        requestData
      );

      const flightData = response.data?.Flight[0];
     


      const status = flightData?.flight_status;
      const flightDate = flightData?.flight_date;
      const flightNumber = flightData?.flight?.number;

      const departureAirport = flightData?.departure?.airport;
      const departureFsCode = flightData?.departure?.iata
      const departureScheduled = flightData?.departure?.scheduled
      const departureEstimated = flightData?.departure?.estimated
      const departureActual = flightData?.departure?.actual
      const departureActualRunway = flightData?.departure?.actual_runway
      const departureTerminal = flightData?.departure?.terminal
      const departureTimezone = flightData?.departure?.timezone


       const arrivalAirport = flightData?.arrival?.airport;
      const arrivalFsCode = flightData?.arrival?.iata
      const arrivalScheduled = flightData?.arrival?.scheduled
      const arrivalEstimated = flightData?.arrival?.estimated
      const arrivalActual = flightData?.arrival?.actual
      const arrivalActualRunway = flightData?.arrival?.actual_runway
      const arrivalTerminal = flightData?.arrival?.terminal
      const arrivalTimezone = flightData?.arrival?.timezone

      const  flightOptionsData = [
          {
            flight_status: status,
            flight_date: flightDate,
            flight_number: flightNumber,
            departure: {
              airport: departureAirport,
              iata: departureFsCode,
              scheduled: departureScheduled,
              estimated: departureEstimated,
              actual: departureActual,
              actual_runway: departureActualRunway,

              terminal: departureTerminal,
              timezone: departureTimezone,
            },
            arrival: {
              airport: arrivalAirport,
              iata: arrivalFsCode,
              scheduled: arrivalScheduled,
              estimated: arrivalEstimated,
              actual: arrivalActual,
              actual_runway: arrivalActualRunway,
              terminal: arrivalTerminal,
              timezone: arrivalTimezone,
            },
          },
        ];



      setFlightData(flightOptionsData);
      setLoading(false);
    } catch (error) {
      setFlightData(null);
      setLoading(false);
      console.error("Error fetching flight options:", error);
    }
  };

  const validateDateFormat = (value) => {
    const mmddyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
    // const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

    // Check format
    if (!mmddyyyy.test(value)) {
      return "Date must be in mm-dd-yyyy format";
    }

    // // Parse date depending on format
    // let parts;
    // let parsedDate;

    // if (ddmmyyyy.test(value)) {
    //   parts = value.split("-");
    //   parsedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`); // yyyy-mm-dd
    // } else {
    //   parsedDate = new Date(value);
    // }

    // // Normalize time
    // parsedDate.setHours(0, 0, 0, 0);
    // const today = new Date();
    // today.setHours(0, 0, 0, 0);

    // if (parsedDate < today) {
    //   return "Date cannot be in the past";
    // }

    return true;
  };

  const loadAirlineOptions = (inputValue, callback) => {
    fetchAirlines(inputValue).then((options) => callback(options));
  };

  const fetchAirlines = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
         `${base_url.api1}/tourapp/flight_states_airlines?${searchBy}=${inputValue}`
        );
        if (response.data && response.data.Airlines) {
          return response.data.Airlines.map((airline) => ({
            value: airline.id,
            label: `${airline.airline_name} ${
              airline.iata_code ? `(${airline.iata_code})` : ""
            }`,
            hub_code: airline.icao_code,
          }));
        }
      } catch (error) {
        console.error("Error fetching airlines:", error);
      }
    }
    return [];
  };

  const fetchInitialAirports = async () => {
    try {
      // Fetch initial airline options
      const airlineResponse = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airlines?sortby=airline_name`
      );
      if (airlineResponse.data && airlineResponse.data.Airlines) {
        const airlineOptions = airlineResponse.data.Airlines.map((airline) => ({
          value: airline.id,
          label: `${airline.airline_name} ${
            airline.iata_code ? `(${airline.iata_code})` : ""
          }`,
          hub_code: airline.iata_code,
        }));
        setDefaultAirlineOptions(airlineOptions);
      }

      const response = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airports?sortby=airport_name`
      );
      if (response.data && response.data.Airports) {
        const options = response.data.Airports.map((airport) => ({
          value: airport.id,
          label: `${airport.airport_name.replace(
            /[\n\u0000-\u001F\u007F-\u009F]/g,
            ""
          )} (${airport.iata_code})`,
        }));

        setDefaultOptions(options);
      }
    } catch (error) {
      console.error("Error fetching initial airports:", error);
    }
  };

  useEffect(() => {
    fetchInitialAirports();
  }, []);

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: "none !important",
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      // width: "280px",
      // maxWidth: "280px",
      // minWidth: "280px",

      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
    }),
    menu: (base) => ({
      ...base,
      background: "#ffffff",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      background: isSelected
        ? "#007bff"
        : isFocused
        ? "#f0f0f0"
        : "transparent",
      color: isSelected ? "#ffffff" : "#000000",
    }),
  };

  return (
    <div>
      <Nav />
      <div className="historic-wrapper">
        <div className="historic-container">
          <div className="historic-header">
            <h2>Flight Schedule</h2>
            <div className="historic-link-wrapper">
              {/* <Link to={"/check-weather"} className="check-weather-link">
                {" "}
                <IconTemperatureSun /> Check Airport Weather Status
              </Link> */}

              {/* <Link
                to={"/delay-statistics"}
                className="check-weather-link"
              
              >
                {" "}
                <IconChartBar /> Check Airport Delay Statistics
              </Link> */}

              <Link
                to={"/flight-tracking"}
                className="check-weather-link"
               
              >
                {" "}
                <IconLiveView /> Flight Live Tracking
              </Link>
            </div>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">

          
  <div className="grid-two" style={{marginBottom:"20px"}}>
                    <div className="custom-input">

                        <label className="input-label">
                        Search by
                        {/* <span style={{ color: "#de8385" }}> *</span> */}
                      </label>

                        <Radio.Group
                                                        value={searchBy}
                                          onChange={(value) => {
                                                                        
                
                                           setSearchBy(value)
                                                                      }}
                                                    >
                          <div className="claim-form-radio-wrapper">
                            
                                                        <Radio
                                                          color="red"
                                                          // checked
                                                          variant="outline"
                                                          value={"airline_name"}
                              label="Airline name"
                              size="xs"
                                            />
                                            
                                                        <Radio
                                                          color="red"
                                                          variant="outline"
                                                          value={"iata_code"}
                              label="Airline code"
                              size="xs"
                              
                                                        />
                                                      </div>
                                                    </Radio.Group>
                    </div>
                    

                  

                   
                  </div>
          
            <div className="grid-three">
              <div className="custom-select" style={{ width: "100%" }}>
                 {/* <div className="airline-radio-wrapper">
                
                                        <Radio.Group
                                                                      value={searchBy}
                                          onChange={(value) => {
                                                                        
                
                                           setSearchBy(value)
                                                                      }}
                                                                    >
                                          <div className="claim-form-radio-wrapper">
                                            <label className="search-by-label">Search by:</label>
                                                                        <Radio
                                                                          color="red"
                                                                          // checked
                                                                          variant="outline"
                                                                          value={"airline_name"}
                                              label="Airline name"
                                              size="xs"
                                                            />
                                                            
                                                                        <Radio
                                                                          color="red"
                                                                          variant="outline"
                                                                          value={"iata_code"}
                                              label="Airline code"
                                              size="xs"
                                              
                                                                        />
                                                                      </div>
                                                                    </Radio.Group>
                                      </div> */}
                <span className="select-label">
                  Airline <span style={{ color: "#de8385" }}> *</span>
                </span>
                <div
                  className="select-box"
                  style={{
                    borderColor: "#E6F6FF",
                    backgroundColor: "#e8eef7",
                  }}
                >
                  <Controller
                    control={control}
                    name="airline"
                    rules={{ required: "Airline is required" }}
                    render={({ field }) => (
                      <AsyncSelect
                        {...field}
                        cacheOptions={false}
                        defaultOptions={defaultAirlineOptions}
                        loadOptions={loadAirlineOptions}
                        value={field.value}
                        onChange={field.onChange}
                        placeholder="Search airline"
                        styles={selectStyles}
                      />
                    )}
                  />
                </div>
                {errors.airline && (
                  <p className="errormessage">{errors.airline.message}</p>
                )}
              </div>

              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Flight number
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="flightNumber"
                  control={control}
                  rules={{
                    required: "Flight Number is Required",
                    validate: (value) => {
                      if (!/^[a-zA-Z0-9]+$/.test(value)) {
                        return "Only letters and numbers are allowed";
                      }
                      if (value.length > 10) {
                        // Change to 7 if needed
                        return "Maximum 10 characters allowed";
                      }
                      return true;
                    },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter flight number"
                      type="text"
                      maxLength={10}
                      onChange={(e) => {
                        const cleanedValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        field.onChange(cleanedValue);
                      }}
                    />
                  )}
                />
                {errors.flightNumber && (
                  <p className="errormessage">{errors.flightNumber.message}</p>
                )}
              </div>

              <div className="custom-date-time-container">
                <label className="custom-date-time-label">
                  Scheduled departure date
                  <span style={{ color: "#de8385" }}>*</span>
                </label>
                <div style={{ position: "relative" }}>
                  <div className="custom-date-time-box">
                    <Controller
                      name={`departureDate`}
                      control={control}
                      rules={{
                        required: "Departure Date is required",
                        validate: validateDateFormat,
                      }}
                      render={({ field }) => (
                        <CustomDOBPicker
                          {...field}
                          inputRequired={true}
                          placeholder="Choose date"
                          inputClassName="custom-date-input"
                          onChange={(value) => {
                            field.onChange(value);
                          }}
                        />
                      )}
                    />
                  </div>{" "}
                  {errors.departureDate && (
                    <p className="errormessage" style={{ marginTop: "12px" }}>
                      {errors.departureDate.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "40px",
              }}
            >
              <CustomButton btnText={"Submit"} style={{ width: "200px" }} />
            </div>
          </form>

          {flightData &&
            flightData.length > 0 &&
            !loading &&
            flightData.map((flight, index) => {
              return <FlightCard flight={flight} key={index} />;
            })}

          {!flightData && !loading && (
            <div className="loading-div">No Data Found</div>
          )}

          {loading && (
            <div className="loading-div">
              <Loader />
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FlightTracking;
